var angular = require('angular');
angular.module('satv.playlist', [
  'ngResource',
  'satv.loader',
  'satv.paginate',
  'satv.readmore',
  'angular-growl',
  'ui.router',
  'satv.confirm',
  'satv.statusHelper'
], function($interpolateProvider) {
    $interpolateProvider.startSymbol('[[');
    $interpolateProvider.endSymbol(']]');
})

//add the config values to the constants
.constant('config', window.app_config)

.run(['$rootScope', 'SelectMyPlaylistsModal', 'PlaylistItems', 'growl', function($rootScope, SelectMyPlaylistsModal, PlaylistItems, growl) {
    var prompt = function (e, subjectsToAdd) {

        var addToPlaylist = function(playlist) {
            //@todo this should not be hard coded
            if ((playlist.count + subjectsToAdd.length) > 500 ) {
                growl.error('Sorry, you cannot have more than 500 tracks in a playlist');
            } else {
                new PlaylistItems({
                    playlistId: playlist.id,
                    subjects: subjectsToAdd
                }).$save(function() {

                }, function(r) {
                    if (r.data.errors && r.data.errors.children && r.data.errors.children.subjects) {
                         angular.forEach(r.data.errors.children.subjects.errors, function(e) {
                            growl.error(e);
                        });
                    }
                });
            }
        };

        //create modal and add success callback
        SelectMyPlaylistsModal.open({
            success: function(args) {
                addToPlaylist(args[1]);
            }
        });
    };

    $rootScope.$on('PLAYLIST_ADD', prompt);
    $rootScope.$on('MEDIALIST_STARTDRAG', prompt);
}])
    .controller('EditMyPlaylistSharesCtrl', require('./controllers/EditMyPlaylistSharesCtrl'))
    .controller('MyPlaylistModalEditCtrl', require('./controllers/MyPlaylistModalEditCtrl'))
    .controller('MyPlaylistShareModalCtrl', require('./controllers/MyPlaylistShareModalCtrl'))
    .controller('PlaylistItemsCtrl', require('./controllers/PlaylistItemsCtrl'))
    .controller('PlaylistLandingCtrl', require('./controllers/PlaylistLandingCtrl'))
    .controller('PlaylistsCtrl', require('./controllers/PlaylistsCtrl'))
    .controller('SelectMyPlaylistModalCtrl', require('./controllers/SelectMyPlaylistModalCtrl'))

    .factory('Playlist', require('./services/Playlist').Playlist)
    .factory('PlaylistLoader', require('./services/Playlist').PlaylistLoader)
    .factory('PlaylistItems', require('./services/Playlist').PlaylistItems)
    .factory('PlaylistItemsLoader', require('./services/Playlist').PlaylistItemsLoader)
    .factory('PlaylistsLoader', require('./services/Playlist').PlaylistsLoader)
    .factory('MyPlaylistShare', require('./services/Playlist').MyPlaylistShare)
    .factory('MyPlaylistModal', require('./services/MyPlaylistModal'))
    .factory('PlaylistShareModal', require('./services/PlaylistShareModal'))
    .factory('SelectMyPlaylistsModal', require('./services/SelectMyPlaylistsModal'))

;



// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistclientbundle/Resources/js/angular/module.js